import { connect } from 'react-redux';
import SideMenu from '../../../components/navbar/SideMenu';
import { profile } from 'core/selectors';

export default connect(
  state => ({
    profile: profile(state),
  }),
  {},
)(SideMenu);
